import { SelectItem } from '@openng/optimus-ui/api';
import { Column } from '../../model/common/column';

export function getCommercialOutageTableColumns(
  availableAors: SelectItem[],
  availableOperatingAreas: SelectItem[],
  availableMarketAreas: SelectItem[]
): Column[] {
  return [
    {
      field: 'facilityName',
      header: 'COMMERCIAL_SERVICES.LABEL.FACILITY_NAME',
      formatPattern: 'text',
      width: '18%',
      sortable: true,
      filterable: true,
      matchMode: 'contains',
    },
    {
      field: 'facilityId',
      header: 'COMMERCIAL_SERVICES.LABEL.FACILITY_ID',
      formatPattern: 'text',
      width: '12%',
      sortable: true,
      filterable: true,
      matchMode: 'contains',
    },
    {
      field: 'outageStartDate',
      header: 'COMMERCIAL_SERVICES.LABEL.START_DATE',
      formatPattern: 'text',
      type: 'calendar',
      dateFormat: 'MM/dd/yyyy',
      width: '14%',
      sortable: true,
      filterable: true,
    },
    {
      field: 'outageEndDate',
      header: 'COMMERCIAL_SERVICES.LABEL.END_DATE',
      formatPattern: 'text',
      type: 'calendar',
      dateFormat: 'MM/dd/yyyy',
      width: '14%',
      sortable: true,
      filterable: true,
    },
    {
      field: 'numberOfUnitsOnOutage',
      header: 'COMMERCIAL_SERVICES.LABEL.UNITS_ON_OUTAGE',
      formatPattern: 'number',
      width: '12%',
      sortable: true,
      filterable: true,
      matchMode: 'equals',
    },
    {
      field: 'numberOfTotalUnits',
      header: 'COMMERCIAL_SERVICES.LABEL.TOTAL_UNITS',
      formatPattern: 'number',
      width: '12%',
      sortable: true,
      filterable: true,
      matchMode: 'equals',
    },
    {
      field: 'aor',
      header: 'COMMERCIAL_SERVICES.LABEL.AOR',
      formatPattern: 'text',
      type: 'dropdown',
      width: '10%',
      sortable: true,
      filterable: true,
      options: availableAors,
      matchMode: 'equals',
    },
    {
      field: 'commercialOperatingArea',
      header: 'COMMERCIAL_SERVICES.LABEL.OPERATING_AREA',
      formatPattern: 'text',
      type: 'dropdown',
      width: '10%',
      sortable: true,
      filterable: true,
      options: availableOperatingAreas,
      matchMode: 'equals',
    },
    {
      field: 'commercialMarketArea',
      header: 'COMMERCIAL_SERVICES.LABEL.MARKET_AREA',
      formatPattern: 'text',
      type: 'dropdown',
      width: '14%',
      sortable: true,
      filterable: true,
      options: availableMarketAreas,
      matchMode: 'equals',
    },
  ];
}
